'use strict'

import { customEventsBus } from '../helpers/CustomEventsBus'
import uuidv4 from 'uuid/v4'

class ConversationStateManager {
  constructor (conversationId) {
    this.conversationId = conversationId
  }

  getConversationId () {
    return this.conversationId
  }

  initConversation () {
    if (this.conversationId) {
      return this.conversationId
    }

    this.conversationId = uuidv4()
    const conversationTtl = new Date()
    conversationTtl.setHours(conversationTtl.getHours() + 1)

    customEventsBus.emitEvent({
      type: 'pvChatbotInitConversation',
      conversation: {
        id: this.conversationId,
        ttl: conversationTtl
      }
    })

    return this.conversationId
  }

  clearConversation () {
    this.conversationId = null

    customEventsBus.emitEvent({
      type: 'pvChatbotClearConversation'
    })
  }
}

const conversationStateManager = new ConversationStateManager()

export {
  conversationStateManager
}



// WEBPACK FOOTER //
// ./src/state/ConversationStateManager.js